import store from '@/store';
import {Route} from 'vue-router';
import {can} from '@/services/acl.service';
import router from '..';

export default async function(to: Route) {
  if (store.getters['auth/isAuthenticated']) {
    await store.dispatch('auth/me');
    /* eslint-disable */
  // eslint-disable-next-line no-use-before-define
    if (!can(to?.meta?.permissions || [])) {
      router.push({
        path: '/unauthorized',
        query: {
          from: to.path,
        },
      });
    }
  }
}
